export const SET_INPUTS = 'SET_INPUTS';
export const SET_FORM = 'SET_FORM';
